import { type ContentHelpers } from "matrix-js-sdk/src/matrix";

export enum BeaconDisplayStatus {
    Loading = "Loading",
    Error = "Error",
    Stopped = "Stopped",
    Active = "Active",
}
export const getBeaconDisplayStatus = (
    isLive: boolean,
    latestLocationState?: ContentHelpers.BeaconLocationState,
    error?: Error,
    waitingToStart?: boolean,
): BeaconDisplayStatus => {
    if (error) {
        return BeaconDisplayStatus.Error;
    }
    if (waitingToStart) {
        return BeaconDisplayStatus.Loading;
    }
    if (!isLive) {
        return BeaconDisplayStatus.Stopped;
    }
    if (!latestLocationState) {
        return BeaconDisplayStatus.Loading;
    }
    return BeaconDisplayStatus.Active;
};
